import { render, staticRenderFns } from "./BookingForm.vue?vue&type=template&id=5dcf3206"
import script from "./BookingForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports